import { RunPipeline } from "./index182.js";
import { rgObjectToDto as rgObjectToDto$1 } from "./index195.js";
import { dtoToAggProps, dtoToRgObject } from "@project-rouge/rg-core";
import { expose } from "comlink";
const RunPipelineWorker = { run: (siteDto, aggPropsDto, cache, briefIndex) => {
	return {
		dto: rgObjectToDto$1(RunPipeline({
			aggProps: dtoToAggProps(aggPropsDto),
			obj: dtoToRgObject(siteDto),
			cache,
			briefIndex
		}).obj),
		cache
	};
} };
expose(RunPipelineWorker);
export { RunPipelineWorker };

//# sourceMappingURL=index239.js.map